import store from "../store"

export default {

	init: function() {
    const t = this
    t.projectMoreLinks = document.querySelectorAll('[project-more-link]')

    if(store.getState().sniffer.isIE11) {
      return false
    }

    t.spaceHolder = document.querySelectorAll('[space-holder]')

    if(t.spaceHolder.length > 0) {
      t.linkMoreProject()
      t.inViewPortAnimation()
    }
  },

  linkMoreProject: function() {
    const t = this

    Array.from(t.projectMoreLinks).forEach(singleMoreLink => {
      singleMoreLink.addEventListener('click', e => {
        let closeWrap = singleMoreLink.getAttribute('project-more-link')
        e.preventDefault()
        t.toggleToMoreProject({
          wrap: e.target.closest('[space-holder]'),
          hide: closeWrap ? true : false
        })
      })
    })
  },

  inViewPortAnimation: function() {
    const t = this

    const inViewport = (entries, observer) => {
      entries.forEach(entry => {
        if(!entry.target.classList.contains("is-inViewport")) {
          entry.target.classList.toggle("is-inViewport", entry.isIntersecting)
        }
      })
    }

    const Obs = new IntersectionObserver(inViewport)
    const obsOptions = {}

    const ELs_inViewport = document.querySelectorAll('[data-inviewport]')
    ELs_inViewport.forEach(EL => {
      Obs.observe(EL, obsOptions)
    })
  },

  toggleToMoreProject: function(options) {
    const t = this

    Array.from(t.spaceHolder).forEach(spaceHolderSingle => {
      Array.from(spaceHolderSingle.querySelectorAll('[data-screen]')).forEach(f => {
        f.removeAttribute('data-screen-open')
        f.removeAttribute('data-screen-more-open')
      })
    })

    if(!options.hide) {
      const screenFirst = options.wrap.querySelector('[data-screen="1"]')
      const screenSecond = options.wrap.querySelector('[data-screen="2"]')
      screenFirst.toggleAttribute('data-screen-open')
      screenSecond.toggleAttribute('data-screen-more-open')
    }
  },
}